import { gql } from '@apollo/client';

export const GET_NOTIFICATIONS = gql`
  query GetNotifications($filterOptions: NotificationFilterOptions, $paginationOptions: PaginationOptions) {
    getNotifications(filterOptions: $filterOptions, paginationOptions: $paginationOptions) {
      edges {
        node {
          id
          notificationDate
          omsLinkId
          orderId
          campaignId
          acknowledgement {
            acknowledgedBy
            acknowledgedDate
          }
          events {
            id
            modifiedBy
            modifiedDate
            acknowledgement {
              acknowledgedBy
              acknowledgedDate
            }
            changeList {
              ... on SingleValueChange {
                fieldName
                oldValue {
                  action
                  payload
                }
                newValue {
                  action
                  payload
                }
              }
              ... on MultiValueChange {
                fieldName
                oldValues {
                  action
                  payload
                }
                newValues {
                  action
                  payload
                }
              }
            }
            object {
              __typename
            }
            correlationId
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      total
    }
  }
`;
